var module = angular.module('octopusApp.accounts');

module.controller('AccountEditController', function($scope, $q, $stateParams, busy, octopusRepository, $location, pollLoop, octopusLog) {
    var vm = this;
    var isLoading = vm.isLoading = busy.create();
    var isSaving = vm.isSaving = busy.create();
    var isTesting = vm.isTesting = busy.create();

    var id = $stateParams.accountId;
    var accountType = $location.search().accountType;
    var loop;
    var unavailableTenants = [];
    var unavailableEnvironments = [];

    vm.save = save;
    vm.teamSensitiveValues = { EnvironmentIds: [], TenantIds: [] };

    function init() {
        var tenantsP = octopusRepository.Tenants ? octopusRepository.Tenants.all().then(function (tenants) {
            vm.availableTenants = tenants;
        }) : $q.resolve([]);

        var environmentsP = octopusRepository.Environments.all().then(function (environments) {
            vm.environments = environments;
        });

        isLoading.promise($q.all([tenantsP, environmentsP]).then(function () {
            if (id) {
                configureFromExisting();
            } else {
                configureFromNew();
            }
        }));
    }

    function configureFromNew(){
        vm.account = { AccountType: accountType, EnvironmentIds: [] };
    }

    function configureFromExisting(){
        isLoading.promise(octopusRepository.Accounts.get(id).then(function (account) {
            vm.account = account;

            vm.teamSensitiveValues.EnvironmentIds = vm.environments.filter(function(m){ return account.EnvironmentIds.indexOf(m.Id) !== -1; }).map(function(e){return e.Id;});
            vm.teamSensitiveValues.TenantIds = vm.availableTenants
                ? vm.availableTenants.filter(function(t){return account.TenantIds.indexOf(t.Id) !== -1;}).map(function(e){return e.Id;})
                : [];

            unavailableTenants = account.TenantIds.filter(function(tid) { return vm.teamSensitiveValues.TenantIds.indexOf(tid) === -1; });
            unavailableEnvironments = account.EnvironmentIds.filter(function(tid) { return vm.teamSensitiveValues.EnvironmentIds.indexOf(tid) === -1; });
        }));
    }

    function save(testAzureAccount) {
        vm.account.EnvironmentIds = [].concat(unavailableEnvironments).concat(vm.teamSensitiveValues.EnvironmentIds);
        vm.account.TenantIds = [].concat(unavailableTenants).concat(vm.teamSensitiveValues.TenantIds);

        isSaving.promise(octopusRepository.Accounts.save(vm.account).then(function(saved){
            if (testAzureAccount)
            {
                vm.account = saved;
                var task = {
                    Name: 'TestAzureAccount',
                    Description: 'Test Azure account',
                    Arguments: { AccountId: saved.Id }
                };

                isSaving.promise(octopusRepository.Tasks.create(task).then(function(task){
                    $scope.accountTestTask = task;
                    loop = pollLoop.create($scope, function () { return refreshAccountTest(); }, 1000);
                    loop.startImmediately();
                }));
            }
            else {
                $location.path("/accounts");
            }
        }));
    }

    var refreshAccountTest = function () {
        return isTesting.promise(octopusRepository.Tasks.get($scope.accountTestTask.Id)).then(function(task) {
            $scope.accountTestTask = task;
            if (task.State === "Success" || task.State === "Failed" || task.State === "TimedOut") {
                octopusLog.log("Task has finished; no more refreshing");
                loop.stop();
            }
        });
    };

    init();
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/accounts/controllers/account_edit_controller.js
// module id = 370
// module chunks = 1